export default __webpack_public_path__ + "images/2f85025c97758760ed9ed814225528be-trustly_bank.png";